import React, {Fragment} from "react";
import StepLoadingComponent from "components/Step/StepLoadingComponent";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import RegistrationV2Service from "../../../../services/Registration/RegistrationV2Service";
import ToastHelper from "../../../../utils/ToastHelper";
import MsisdnSearchStripper from "../../../../utils/MsisdnSearchStripper";


export default class SubmitStep extends React.Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            submitting: false
        }
    }

    componentDidMount() {
        this.submit();
    }

    submit() {
        let capturedData = this.props.capturedData;

        let registrationElements = Object.keys(RegistrationElements);
        let submissionData = {};

        let limitDocumentData = this.getLimitDocumentToSubmit();
        let additionalDocumentData = this.getAdditionalDocumentToSubmit();

        Object.keys(limitDocumentData).forEach((index) => {
            submissionData[index] = limitDocumentData[index]
        })
        Object.keys(additionalDocumentData).forEach((index) => {
            submissionData[index] = additionalDocumentData[index];
        })
        registrationElements.forEach(registrationElement => {
            let elementKey = RegistrationElements[registrationElement];

            if (capturedData[elementKey].length !== 0) {

                if(elementKey === RegistrationElements.MSISDN){
                    submissionData[elementKey] = MsisdnSearchStripper.stripMsisdn(capturedData[elementKey]);
                }
                else {
                    submissionData[elementKey] = capturedData[elementKey];
                }
            }
        });
        RegistrationV2Service.createRegistration(submissionData).then(response => {
            if (response.id) {
                if (this.props.onSubmitSuccessful)
                    this.props.onSubmitSuccessful(response);
            } else {
                ToastHelper.formatError(response)
                this.setState({
                    submitting: false
                }, this.props.onBackClick);
            }
        });
    }

    getLimitDocumentToSubmit() {
        let requiredDocuments = this.props.limitTierSetDocumentsResponse["requiredDocuments"];

        let registrationElements = {};

        if (requiredDocuments !== undefined && requiredDocuments !== null && requiredDocuments.length !== 0) {
            let limitTierSetId = this.props.limitTierSetDocumentsResponse.limitTierSet.id;
            let limitTierSetName = this.props.limitTierSetDocumentsResponse.limitTierSet.name;
            let limitDocumentPurposes = "";
            let limitDocumentTypes = "";
            let limitDocumentMetaDataIds = "";
            let comma = "";

            for (let index = 0; index < requiredDocuments.length; index++) {
                let documentPurpose = this.props.limitTierSetDocumentsResponse["requiredDocuments"][index]["documentPurpose"]
                let limitDocument = this.props.limitDocuments[documentPurpose];

                if (index !== 0) {
                    comma = ",";
                }

                limitDocumentPurposes = limitDocumentPurposes + comma + documentPurpose;
                limitDocumentTypes = limitDocumentTypes + comma + limitDocument["document-type"].id
                limitDocumentMetaDataIds = limitDocumentMetaDataIds + comma + limitDocument["inbound-limit-document-meta-data-id"]
            }

            registrationElements = {
                "inbound-limit-tier-set-id": limitTierSetId,
                "inbound-limit-tier-set-name": limitTierSetName,
                "inbound-limit-document-purposes": limitDocumentPurposes,
                "inbound-limit-document-type-ids": limitDocumentTypes,
                "inbound-limit-document-metadata-ids": limitDocumentMetaDataIds
            }
        }

        return registrationElements;
    }

    getAdditionalDocumentToSubmit() {
        let additionalDocuments = this.props.additionalDocuments;

        let registrationElements = {};

        if (additionalDocuments !== undefined && additionalDocuments !== null && additionalDocuments.length !== 0) {
            let additionalDocumentPurposes = "";
            let additionalDocumentTypes = "";
            let additionalDocumentMetaDataIds = "";
            let comma = "";
            let index = 0;

            Object.keys(additionalDocuments).forEach((key) => {
                let documentPurpose = key;
                let additionalDocument = this.props.additionalDocuments[documentPurpose];

                if (index !== 0) {
                    comma = ",";
                }

                additionalDocumentPurposes = additionalDocumentPurposes + comma + documentPurpose;
                additionalDocumentTypes = additionalDocumentTypes + comma + additionalDocument["document-type"].id
                additionalDocumentMetaDataIds = additionalDocumentMetaDataIds + comma + additionalDocument["additional-document-metadata-id"]
                index++;
            })


            registrationElements = {
                "additional-document-purposes": additionalDocumentPurposes,
                "additional-document-type-ids": additionalDocumentTypes,
                "additional-document-metadata-ids": additionalDocumentMetaDataIds
            }
        }

        return registrationElements;
    }

    render() {
        return <StepLoadingComponent
            message={<Fragment>&nbsp;&nbsp;&nbsp;&nbsp;Submitting...</Fragment>}
        />
    }
}